import React from 'react';

import { Box, Container, Grow, Typography } from '@material-ui/core';

import Logo from '../../../assets/pede-pronto-logo-large.png';
import { useStyles } from './generic-box.styles';

interface Props {
  children?: React.ReactNode;
  className?: string;
  title?: string;
  subtitle?: string;
  id: string;
}

export default function GenericBox(props: Props) {
  const classes = useStyles();

  return (
    <Box id={props.id}>
      <Grow in={true} timeout={700}>
        <Container className={classes.container}>
          <img className={classes.logo} src={Logo} alt='Pede Pronto' />
          {props.title && (
            <Typography className={classes.title} variant='h5'>
              {props.title}
            </Typography>
          )}
          {props.subtitle && (
            <Typography className={classes.subtitle} variant='body2' align='center'>
              {props.subtitle}
            </Typography>
          )}
          {props.children}
        </Container>
      </Grow>
    </Box>
  );
}
